import { equipmentAPI } from "api";

export const getAllMachineTypeAPI = (payload) => {
    return equipmentAPI.post("api/machinedetail/getall", payload)
        .then((res) => res);
};